export const API_URL = "https://high-score-api.onrender.com/api/v1/games";
export const BG_IMG =
  "https://cdn.pixabay.com/photo/2019/05/29/16/00/retro-4237850_1280.jpg";
